export const LANGUAGE_REQUEST = "LANGUAGE_REQUEST";
export const LANGUAGE_SUCCESS = "LANGUAGE_SUCCESS";
export const LANGUAGE_FAILED = "LANGUAGE_FAILED";

export const COUNTRY_CODE_REQUEST = "COUNTRY_CODE_REQUEST";
export const COUNTRY_CODE_SUCCESS = "COUNTRY_CODE_SUCCESS";
export const COUNTRY_CODE_FAILED = "COUNTRY_CODE_FAILED";
